"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_monitor__brightness__contrast(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "3cdf1ef9-d5d0-4bb2-bbd2-a3e81f7c77ea",
    "data-name": "Apps_ic",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("title", null, "monitor-brightness-contrast-mid"), /*#__PURE__*/React.createElement("g", {
    id: "9f9e028b-518f-42bd-a150-a44de554f4c6",
    "data-name": "Apps_ic_hi"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "545f490f-cdc5-42f7-9f9b-05e0e255bed4",
    "data-name": "Bounding Box",
    width: 192,
    height: 192,
    fill: "none"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 18.02,
    y: 18,
    width: 156,
    height: 156,
    rx: 76,
    ry: 76,
    fill: "none",
    stroke: "#666",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 18,
    width: 156,
    height: 156,
    rx: 76,
    ry: 76,
    fill: "none",
    stroke: "#666",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,96",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#666",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,96",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#666",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 96.02,
    y1: 36.47,
    x2: 96.02,
    y2: 52.36,
    fill: "none",
    stroke: "#e60000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4.05
  }), /*#__PURE__*/React.createElement("line", {
    x1: 96.02,
    y1: 139.64,
    x2: 96.02,
    y2: 155.53,
    fill: "none",
    stroke: "#e60000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4.05
  }), /*#__PURE__*/React.createElement("line", {
    x1: 36.47,
    y1: 96,
    x2: 52.36,
    y2: 96,
    fill: "none",
    stroke: "#e60000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4.05
  }), /*#__PURE__*/React.createElement("line", {
    x1: 139.64,
    y1: 96,
    x2: 155.53,
    y2: 96,
    fill: "none",
    stroke: "#e60000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4.05
  }), /*#__PURE__*/React.createElement("line", {
    x1: 54.05,
    y1: 53.77,
    x2: 65.28,
    y2: 65.01,
    fill: "none",
    stroke: "#e60000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4.05
  }), /*#__PURE__*/React.createElement("line", {
    x1: 126.99,
    y1: 126.72,
    x2: 138.23,
    y2: 137.95,
    fill: "none",
    stroke: "#e60000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4.05
  }), /*#__PURE__*/React.createElement("line", {
    x1: 53.77,
    y1: 138.23,
    x2: 65.01,
    y2: 126.99,
    fill: "none",
    stroke: "#e60000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4.05
  }), /*#__PURE__*/React.createElement("line", {
    x1: 126.72,
    y1: 65.28,
    x2: 137.95,
    y2: 54.05,
    fill: "none",
    stroke: "#e60000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96.16,
    cy: 95.91,
    r: 30.09,
    fill: "none",
    stroke: "#666",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.06,65.83a30.09,30.09,0,1,1,0,60.17Z",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#666",
    strokeLinejoin: "round",
    strokeWidth: 4
  }));
}

var _default = ic_monitor__brightness__contrast;
exports.default = _default;